import ButtonVariants from "@core-components/button/ButtonVariants";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Stack } from "@mantine/core";
import type IBlog from "@models/IBlog";
import UpdatedAt from "../blog/UpdatedAt";
import WrittenBy from "../blog/WrittenBy";
import BlogWidget from "./BlogWidget";

interface Props {
  blog?: IBlog;
}

const BlogFooter: React.FC<Props> = ({ blog }) => {
  const { t } = useAppTranslation("components.blog");
  const { locationUrlBuilder } = useAppLanguage();

  return (
    <Stack align="center" className="mt-12 w-full">
      <Stack className="w-full sm:w-4/5">
        <Stack
          align="center"
          className="my-10 w-full"
          gap={50}
          justify="center"
        >
          <BlogWidget widgetType={blog?.endWidget} />

          <Stack className="w-full">
            <UpdatedAt blog={blog} />
            <WrittenBy blog={blog} />
          </Stack>

          <ButtonVariants.BackRounded
            href={locationUrlBuilder(EPublicRoutes.BLOGS)}
            label={t("backToBlog")}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BlogFooter;
